/* tslint:disable:restrict-plus-operands */
import { createSelector } from '@opengov/compose-app/reselect';

import { viewSelector } from './viewState';

export const selectIsModalOpen = createSelector(
  viewSelector,
  viewState => viewState.isModalOpen
);
export const selectIsContextMenuOpen = createSelector(
  viewSelector,
  viewState => viewState.isContextMenuOpen
);

export const selectToast = createSelector(
  viewSelector,
  state => state.get('toast', {})
);
export const selectIsToastOpen = createSelector(
  viewSelector,
  state => state.get('isToastOpen', false)
);

export const selectCapitalToast = createSelector(
  viewSelector,
  state => state.get('capitalToast', {})
);
export const selectIsCapitalToastOpen = createSelector(
  viewSelector,
  state => state.get('isCapitalToastOpen', false)
);
